import { useTranslation } from 'react-i18next';

export default function WhyUsSection() {
  const { t } = useTranslation();

  const reasons = [
    { icon: 'ri-medal-line', titleKey: 'whyus_r1_title', descKey: 'whyus_r1_desc' },
    { icon: 'ri-price-tag-3-line', titleKey: 'whyus_r2_title', descKey: 'whyus_r2_desc' },
    { icon: 'ri-time-line', titleKey: 'whyus_r3_title', descKey: 'whyus_r3_desc' },
  ];

  return (
    <section className="py-24 bg-stone-900 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-16 items-start">
          {/* Left */}
          <div className="w-full lg:w-2/5">
            <p className="text-red-400 text-xs uppercase tracking-[0.3em] font-semibold mb-3">{t('whyus_label')}</p>
            <h2
              className="text-4xl md:text-5xl font-black leading-tight mb-6"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              {t('whyus_title_1')}<br />
              <span className="text-red-400">{t('whyus_title_2')}</span>
            </h2>
            <p className="text-stone-400 text-base leading-relaxed mb-8">{t('whyus_desc')}</p>
            <a
              href="mailto:contact@MAXSails.ca"
              className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-red-600 text-white text-sm font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line" />
              {t('whyus_email_btn')}
            </a>
          </div>

          {/* Right */}
          <div className="w-full lg:w-3/5 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {reasons.map((r) => (
              <div key={r.titleKey} className="bg-stone-800 rounded-2xl p-7">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-red-600/20 mb-4">
                  <i className={`${r.icon} text-red-400 text-lg`} />
                </div>
                <h3 className="font-bold text-white text-base mb-2" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  {t(r.titleKey)}
                </h3>
                <p className="text-stone-400 text-sm leading-relaxed">{t(r.descKey)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
